var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconSocialAndroid = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2996_19713)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 40H10C7.34787 39.9999 4.8044 38.9463 2.92906 37.0709C1.05372 35.1956 0.000116023 32.6521 0 30L0 10C0.000116023 7.34787 1.05372 4.8044 2.92906 2.92906C4.8044 1.05372 7.34787 0.000116023 10 0L30 0C32.6522 0 35.1957 1.05357 37.0711 2.92893C38.9464 4.8043 40 7.34784 40 10V30C40 32.6522 38.9464 35.1957 37.0711 37.0711C35.1957 38.9464 32.6522 40 30 40Z",
    fill: "#62B965"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 11.25H30C31.442 11.2499 32.829 10.696 33.8744 9.70276C34.9198 8.70948 35.5439 7.35266 35.6177 5.9125C35.6915 4.47235 35.2094 3.05885 34.271 1.96391C33.3326 0.868981 32.0095 0.176239 30.575 0.02875C30.3838 0.018125 30.1944 0 30 0H10C7.34787 0.000116023 4.8044 1.05372 2.92906 2.92906C1.05372 4.8044 0.000116023 7.34787 0 10L0 30C0.000116027 25.0272 1.97559 20.2582 5.49188 16.7419C9.00816 13.2256 13.7772 11.2501 18.75 11.25Z",
    fill: "#7AC47C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20C28.0222 20 26.0888 20.5865 24.4443 21.6853C22.7998 22.7841 21.5181 24.3459 20.7612 26.1732C20.0043 28.0004 19.8063 30.0111 20.1922 31.9509C20.578 33.8907 21.5304 35.6725 22.9289 37.0711C24.3275 38.4696 26.1093 39.422 28.0491 39.8079C29.9889 40.1937 31.9996 39.9957 33.8268 39.2388C35.6541 38.4819 37.2159 37.2002 38.3147 35.5557C39.4135 33.9112 40 31.9778 40 30V10C40 12.6522 38.9464 15.1957 37.0711 17.0711C35.1957 18.9464 32.6522 20 30 20Z",
    fill: "#46AD4A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2996_19713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.107 15.8184C10.2402 15.8184 9.5376 16.521 9.5376 17.3878V24.7116C9.5376 25.5784 10.2402 26.281 11.107 26.281C11.9737 26.281 12.6764 25.5784 12.6764 24.7116V17.3878C12.6764 16.521 11.9737 15.8184 11.107 15.8184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8936 15.8184C28.0269 15.8184 27.3242 16.521 27.3242 17.3878V24.7116C27.3242 25.5784 28.0269 26.281 28.8936 26.281C29.7604 26.281 30.463 25.5784 30.463 24.7116V17.3878C30.463 16.521 29.7604 15.8184 28.8936 15.8184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7547 15.8184H14.2458C13.9569 15.8184 13.7227 16.0526 13.7227 16.3415V24.7116C13.7224 25.9548 14.5972 27.0263 15.8152 27.275V30.9892C15.8152 31.856 16.5179 32.5586 17.3846 32.5586C18.2514 32.5586 18.954 31.856 18.954 30.9892V27.3273H21.0466V30.9892C21.0466 31.856 21.7492 32.5586 22.616 32.5586C23.4827 32.5586 24.1854 31.856 24.1854 30.9892V27.275C25.4034 27.0263 26.2781 25.9548 26.2779 24.7116V16.3415C26.2779 16.0526 26.0436 15.8184 25.7547 15.8184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8035 9.61517L25.0789 8.34082C25.2867 8.14008 25.2924 7.80894 25.0918 7.60109C24.891 7.39329 24.5599 7.38756 24.352 7.58824C24.3477 7.59246 24.3434 7.59673 24.3392 7.60109L22.8535 9.08682C21.0339 8.29639 18.9678 8.29639 17.1482 9.08682L15.6625 7.60006C15.4547 7.39933 15.1235 7.40511 14.9228 7.61291C14.727 7.81566 14.727 8.13704 14.9228 8.33974L16.1971 9.61512C14.6436 10.6431 13.7131 12.3852 13.7227 14.248C13.7227 14.5369 13.957 14.7711 14.2459 14.7711H25.7548C26.0437 14.7711 26.278 14.5369 26.278 14.248C26.2875 12.3852 25.3571 10.6431 23.8035 9.61517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3845 12.6791C17.6734 12.6791 17.9076 12.4449 17.9076 12.156C17.9076 11.867 17.6734 11.6328 17.3845 11.6328C17.0956 11.6328 16.8613 11.867 16.8613 12.156C16.8613 12.4449 17.0956 12.6791 17.3845 12.6791Z",
    fill: "#62B965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6159 12.6791C22.9048 12.6791 23.1391 12.4449 23.1391 12.156C23.1391 11.867 22.9048 11.6328 22.6159 11.6328C22.327 11.6328 22.0928 11.867 22.0928 12.156C22.0928 12.4449 22.327 12.6791 22.6159 12.6791Z",
    fill: "#62B965"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2996_19713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2996_19713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1163,
    height: 25.1163,
    fill: "white",
    transform: "translate(7.44189 7.44141)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSocialAndroid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Social-android.7dd57a41.svg";
export { ForwardRef as ReactComponent };